import { Box, Typography, styled } from '@mui/material'
import Stack from '@mui/material/Stack'
import { useTranslate } from '@tolgee/react'
import { ArrowDownRightIcon, ArrowUpLeftIcon } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { WorkInstructionUIStore } from '../../stores/work-instruction.ui-store'

interface Props {
  store: WorkInstructionUIStore
}

const Item = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(1),
  backgroundColor: theme.palette.grey[200],
  width: '50%',
  height: theme.spacing(6),
}))

interface WIIconCountProps {
  icon: React.ReactNode
  label: string
  value: number
}

const WIIconCount = ({ icon, label, value }: WIIconCountProps) => (
  <>
    {icon}
    <Typography variant='subtitle2'>{label}</Typography>
    <Typography variant='h4'>{value}</Typography>
  </>
)

export const WorkInstructionCount = observer(({ store }: Props) => {
  const { t } = useTranslate()
  return (
    <Stack
      direction='row'
      alignItems='center'
      sx={{
        border: `1px solid rgba(145, 158, 171, 0.24)`,
      }}
    >
      <Item
        sx={{
          borderRight: `1px solid rgba(145, 158, 171, 0.24)`,
        }}
      >
        <Stack spacing={1} direction='row' alignItems='center' sx={{ margin: 1 }}>
          <Typography variant='subtitle2'>{t('vessel', 'Vessel')}</Typography>
          <WIIconCount
            icon={<ArrowDownRightIcon />}
            label={t('in', 'In')}
            value={store.vesselDischargeTotal}
          />
          <WIIconCount
            icon={<ArrowUpLeftIcon />}
            label={t('out', 'Out')}
            value={store.vesselLoadTotal}
          />
        </Stack>
      </Item>
      <Item>
        <Stack spacing={1} direction='row' alignItems='center' sx={{ margin: 1 }}>
          <Typography variant='subtitle2'>{t('truck', 'Truck')}</Typography>
          <WIIconCount
            icon={<ArrowDownRightIcon />}
            label={t('in', 'In')}
            value={store.truckDischargeTotal}
          />
          <WIIconCount
            icon={<ArrowUpLeftIcon />}
            label={t('out', 'Out')}
            value={store.truckLoadTotal}
          />
        </Stack>
      </Item>
    </Stack>
  )
})
